export enum ControlType {
  BUTTON = "BUTTON",
  LINK = "LINK",
}
